// The reader renders this addon into the content element of the shadow DOM
// (the isolated DOM tree that holds the mkdocs page). A style element in a
// shadow tree applies to the whole tree. The reader renders the addon again
// into the new page DOM after each page change, so the rules need no observer.
// Before a page loads, the reader puts the addon into document.body, where no
// element has these mkdocs classes.
const OVERRIDE_CSS = `
  /* The docs sidebar (DocsSidebar) replaces the mkdocs navigation.
     mkdocs-material: a fixed 16rem column on wide screens, a drawer on narrow ones. */
  .md-sidebar--primary {
    display: none !important;
  }

  /* Below 76.25em the TechDocs reader adds a button (#toggle-sidebar) that
     opens the mkdocs drawer. The drawer is hidden, so the button only shows
     the dim overlay of the drawer. */
  #toggle-sidebar,
  .md-overlay {
    display: none !important;
  }

  /* The previous and next links of the mkdocs footer stay. Readers use them
     on the legacy site, and on a multi-page category doc they are the only
     links between the pages. mkdocs-material on wide screens: position: fixed at
     the bottom of the window, over the content and the TOC, with an inline
     width of the full doc. The links go after the end of the doc, in the
     content column (the same width and margin as .md-content below). */
  .md-footer {
    position: static !important;
    width: auto !important;
  }

  /* mkdocs-material sets an inline TOC height: the distance from the TOC top to the
     footer top. Here the footer ends the doc, so that height can be taller
     than the window, and the end of a long TOC goes out of view. The TOC
     ends at the bottom of the window: with height: auto, the inline top
     and this bottom set the height. */
  .md-sidebar--secondary {
    height: auto !important;
    bottom: 0 !important;
  }

  /* mkdocs-material: max-width: calc(100% - 16rem * 2) and margin-left: 16rem, room
     for the 2 mkdocs sidebars. Only the TOC on the right stays, so the left
     margin goes. 12rem keeps room for the TOC. The -1rem moves the text
     closer to the docs sidebar. Below 76.25em the TechDocs reader hides the
     TOC and gives the content the full width, so these rules apply only above it. */
  @media screen and (min-width: 76.25em) {
    .md-content,
    .md-footer {
      max-width: calc(100% - 12rem) !important;
      margin-left: -1rem !important;
    }
  }

  /* mkdocs-material: padding-top .6rem, and a ::before block of
     .4rem height above the first heading. DocsLayout sets the space above
     the content column, so the heading starts at its top. */
  .md-content__inner {
    padding-top: 0 !important;
  }
  .md-content__inner::before {
    display: none !important;
  }
`;

/**
 * The CSS that fits a mkdocs page into the docs reader page: it hides the
 * mkdocs navigation, gives the content the free space, moves the previous
 * and next links below the content, and removes the space above the first
 * heading. A TechDocs addon at the `Content` location.
 */
export function MkDocsLayoutStyles() {
  return <style>{OVERRIDE_CSS}</style>;
}
